import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Form, InputGroup } from "react-bootstrap";

import Wrapper from "../../components/Wrapper";
import BookingsTable from "../../components/tables/BookingTable";
import { 
  fetchUserBookings, 
  resetBookingsState 
} from "../../store/features/user/BookingsSlice";
import { getRole } from "../../utils/role";

import "../../styles/reports.css";

const UserBookings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const role = getRole();

  // Local state for search input
  const [searchTerm, setSearchTerm] = useState("");
  
  // Redux state
  const {
    bookings,
    status,
  } = useSelector((state) => state.userBookings);

  // --- Initial Fetch ---
  const loadData = useCallback(() => {
    dispatch(fetchUserBookings({ id, page: 1, limit: 10, keyword: searchTerm.trim() }));
  }, [dispatch, id, searchTerm]);

  useEffect(() => {
    loadData();
    return () => {
      dispatch(resetBookingsState());
    };
  }, [loadData, dispatch]);

  const handleSearch = () => {
    if (role === 'SUPPORT') {
        loadData();
    } 
  };

  const handleUpdateClick = (bookingData) => {
    navigate(`/bookings/edit/${bookingData.booking_id}`);
  };

  // --- Client-Side Filtering Logic  ---
  const getDisplayData = () => {
      if (role === 'FIELD_OFFICER') {
          if (!searchTerm) return bookings;
          
          const lowerTerm = searchTerm.toLowerCase();
          return bookings.filter(item => 
            Object.values(item).some(val => 
                String(val).toLowerCase().includes(lowerTerm)
            )
          );
      }
      return bookings;
  };

  const tableData = getDisplayData();

  return (
    <Wrapper>
      <div className="reports-container py-4">
        <div className="d-flex flex-column flex-md-row justify-content-between mb-3 w-100">
          <h1 className="fw-bolder">Bookings</h1>
          
          <div className="d-flex justify-content-end align-items-center position-relative mt-3 m-md-0">
            {/* Search Bar */}
            <div className="position-relative mx-2">
              <InputGroup className="border-2">
                <Form.Control
                  placeholder="Search"
                  aria-label="Search"
                  type="text"
                  className="border-none outline-none"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                />
                <Button
                  variant="primary"
                  className="rounded-end rounded-start-0"
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </InputGroup>
            </div>
          </div>
        </div>

        {status === "loading" ? (
          <h2 className="text-center mt-5">Loading...</h2>
        ) : (
          <BookingsTable 
            bookings={tableData} 
            onUpdateClick={handleUpdateClick}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default UserBookings;